import L from 'leaflet/dist/leaflet.js'; // eslint-disable-line no-unused-vars
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  init() {
    // JavaScript to be fired on the about us page
    $(document).ready(function(){
      var mymap = L.map('tippkarte', { scrollWheelZoom: false }).setView([pincomp[0].lat, pincomp[0].lng], 11); // eslint-disable-line
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {
        foo: 'bar', 
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
      }).addTo(mymap);


      var markers = new Array();
      pins.forEach(showPins); // eslint-disable-line

      function showPins(item, index) {
        //console.log(index + ': ' + item.lng);
        markers[index] = L.marker([item.lat, item.lng]).addTo(mymap);

        markers[index].bindPopup(item.markerlabel);
      }

      var villinoMarker = L.marker([pincomp[0].lat, pincomp[0].lng]).addTo(mymap); // eslint-disable-line
      villinoMarker.bindPopup(pincomp[0].markerlabel); // eslint-disable-line

      if (pincomp[0].open == 1) { // eslint-disable-line
        villinoMarker.openPopup();
      }

      $('.button-karte').on('click', function(){
        mymap.setView([$(this).attr('data-lat'), $(this).attr('data-lng')], 11);
        //mymap.setZoom($(this).attr('data-zoom'));
        //mymap.setZoom(11);
        $('html, body').animate({
          scrollTop: $('#tippkarte').offset().top - 110,
        }, 1000);
        markers[$(this).attr('data-id')].openPopup();
      });
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/mapinpage.js